module.exports = __webpack_public_path__ + "static/media/tropicalsunday.358727af.jpg";